import { ReactElement } from "react";

import { ICatalogue } from "../../../apis/useGetCatalogueData/types";
import { useEventTriggeredTimeUpdate } from "../../../common/hooks/useEventTriggeredTimeUpdate";
import { CART_PAGE_EVENT } from "../constants";
import CartBcrsItem from "./CartBcrsItem";
import CartItem from "./CartItem";
import CartTakeawayItem from "./CartTakeawayItem";
import { useCartItemRemove } from "./useCartItemRemove";

interface IProps {
	cart: ICatalogue[];
}

const CartContainer = ({ cart }: IProps): ReactElement => {
	const key = useEventTriggeredTimeUpdate(CART_PAGE_EVENT.REFRESH_PAGE);

	useCartItemRemove();

	return (
		<ul className="CartContainer" key={key}>
			{cart.map((item, index) => (
				<CartItem item={item} idx={index} key={`${index}-${item.brand_menu_item_id}`} />
			))}
			<CartBcrsItem />
			<CartTakeawayItem />
		</ul>
	);
};

export default CartContainer;
